﻿document.addEventListener('DOMContentLoaded', function() {
    const downloadSelected = document.getElementById('downloadSelected');
    if (downloadSelected) {
        downloadSelected.addEventListener('click', function(e) {
            e.preventDefault();
            let checkboxes = document.querySelectorAll<HTMLInputElement>('.form-check-input:checked');
            checkboxes.forEach(function(checkbox) {
                let link = document.createElement('a');
                link.href = checkbox.value;
                link.download = '';
                document.body.appendChild(link);
                link.dispatchEvent(new MouseEvent('click'));
                document.body.removeChild(link);
            });
        });
    }

    const selectAll = document.getElementById('selectAll');
    if (selectAll) {
        selectAll.addEventListener('click', function() {
            let checkboxes = document.querySelectorAll<HTMLInputElement>('.form-check-input.checklist');
            let allChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);
            checkboxes.forEach(function(checkbox) {
                checkbox.checked = !allChecked;
            });
        });
    }

    const downloadChecklistSelected = document.getElementById('downloadChecklistSelected');
    if (downloadChecklistSelected) {
        downloadChecklistSelected.addEventListener('click', function(e) {
            e.preventDefault();
            let checkboxes = document.querySelectorAll<HTMLInputElement>('.form-check-input.checklist:checked');
            checkboxes.forEach(function(checkbox) {
                let link = document.createElement('a');
                link.href = checkbox.value;
                link.download = '';
                document.body.appendChild(link);
                link.dispatchEvent(new MouseEvent('click'));
                document.body.removeChild(link);
            });
        });
    }
});
